import { UserManager, WebStorageStateStore } from "oidc-client";
import ApiService from "./api.service";
import { TokenService } from "./token.service";
import store from "@/store";
import { PlanService } from "./plan.service";

const AuthService = {
  userManager: UserManager,
  settings: null,
  userManagerSettings: null,
  refreshToken: null,

  init(settings) {
    this.settings = settings;
    const STS_DOMAIN = settings.AUTH;
    const conf = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: STS_DOMAIN,
      client_id: "vuejs_code_client",
      redirect_uri: this.getOIDCUrl() + "callback.html",
      automaticSilentRenew: false,
      silent_redirect_uri: this.getOIDCUrl() + "silent-renew.html",
      response_type: "code",
      scope:
        "openid profile roles transactions plans members businessrules users content contributions offline_access portal-proxy",
      post_logout_redirect_uri: this.getOIDCUrl(),
      filterProtocolClaims: true,
      accessTokenExpiringNotificationTime: 10,
    };

    this.userManagerSettings = conf;

    this.userManager = new UserManager(conf);
    let self = this;

    this.userManager.events.addUserLoaded((args) => {
      self.userManager.getUser().then((user) => {
        self.handleUser(user);
      });
    });

    this.userManager.events.addSilentRenewError(function(e) {
      console.log("silent renew error", e);

      self.userManager.signinRedirect();
    });

    this.userManager.events.addAccessTokenExpiring(async function() {
      try {
        await self.silentRefresh();
      } catch (error) {
        console.log("Access Token Expiring silent renew error", error);
        self.userManager.signinRedirect();
      }
    });
  },
  getOIDCUrl() {
    return window.location.origin + "/";
  },
  hasAccess(user, allowed, roles) {
    if (allowed.length === 0) {
      return false;
    }

    var role = roles.find((role) => {
      return allowed.includes(role) && user.profile.role.includes(role);
    });
    return !!role;
  },
  handleUser(user) {
    if (user.profile.role === undefined) {
      return this.logout();
    }
    console.log(user);
    TokenService.saveToken(user.access_token);
    TokenService.saveRefreshToken(user.refresh_token);
    store.dispatch("auth/setUser", user.profile.email);
    store.dispatch("auth/setRole", user.profile.role);
    store.dispatch("common/setBrokerId", user.profile.brokerid);
    store.dispatch(
      "common/setEmployers",
      user.profile.employers === null || user.profile.employers === undefined
        ? []
        : JSON.parse(user.profile.employers)
    );
    this.refreshToken = user.refresh_token;
  },
  async getUser() {
    return this.userManager.getUser();
  },
  async login(state) {
    return this.userManager.signinRedirect({ state });
  },
  async logout() {
    TokenService.removeToken();
    PlanService.removePlan();
    return this.userManager.signoutRedirect();
  },
  async getAccessToken() {
    return this.userManager.getUser().then((data) => {
      return data.access_token;
    });
  },
  async getRoles() {
    const url = this.settings.AUTH + "/roles";
    return await ApiService.get(url);
  },
  async silentRefresh() {
    try {
      const user = await this.userManager.signinSilent();
      this.handleUser(user);
      return user;
    } catch (error) {
      console.log("silentRefresh：Refresh failed", error);
      throw error;
    }
  },
};

export default AuthService;
